<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'RowTaskInfo',
})

withDefaults(defineProps<RowTaskInfoProps>(), {
  required: false,
})

interface RowTaskInfoProps {
  title: string
  required?: boolean
}

</script>

<template>
  <div class="row-task-info">
    <div class="row-task-info__title">
      <AppText
        name="body1"
        color="slate-500"
      >
        {{ title }}
      </AppText>
      <span
        v-if="required"
        class="row-task-info__required"
      >*</span>
    </div>
    <div class="row-task-info__box">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped src="./RowTaskInfo.scss" />
